import useFeaturePermissions from '@hooks/permissions/useFeaturePermissions.ts';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity text
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useTextsPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(organizationId, Permissions.TextsChange, Permissions.TextsRead);
  return { writePermission, readPermission };
};
